import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect } from 'react';

export default function Preloader() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Toplam 2.2 saniye sonra ekranı kaldırıyoruz (tiyatro perdesi kalkıyor)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          key="preloader"
          // Perde aşağı çekiliyormuş/şeffaflaşıyormuş gibi çıkış animasyonu yapıyoruz
          exit={{ opacity: 0, scale: 1.05, filter: "blur(10px)" }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="fixed inset-0 z-[99999] flex items-center justify-center bg-white pointer-events-none"
        >
          {/* Lüks Mimari Doku */}
          <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] mix-blend-multiply"></div>
          
          <div className="relative flex flex-col items-center">
            {/* Ana Logo Gelişi */}
            <motion.div
              initial={{ opacity: 0, y: 20, filter: "blur(10px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
            >
              <img
                src="https://static.readdy.ai/image/462a574349d19c517babfc55bf63e079/c8ac21bc970c8b7e4f4c5b80839b9d5d.png"
                alt="KARE YAPI"
                className="w-56 md:w-72 drop-shadow-2xl"
              />
            </motion.div>

            {/* Gösterişli ve Kalın Kırmızı İlerleme Çubuğu */}
            <motion.div 
               initial={{ opacity: 0 }}
               animate={{ opacity: 1 }}
               transition={{ duration: 0.5, delay: 0.8 }}
               className="w-48 md:w-64 h-[6px] bg-gray-200 rounded-full mt-12 overflow-hidden shadow-inner"
            >
              <motion.div 
                className="h-full bg-red-600 shadow-[0_0_15px_rgba(220,38,38,0.6)]"
                initial={{ width: "0%" }}
                animate={{ width: "100%" }}
                transition={{ duration: 1.2, delay: 0.8, ease: "easeInOut" }}
              />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
